<template>
  <article class="article u-bg-black u-overflow-y-scroll" :class="[ isReadMode ? 'u-full-height u-pad-x-1of8 u-pad-x-sm--sm' : '' ]">
    <div class="article__content u-pad-x-md" :class="[ isReadMode ? 'u-pad-y-xl u-pad-x-0--sm' : 'u-pad-y-md' ]">
      <router-link v-if="!isReadMode" :to="'/district/' + $route.params.slug + '/' + $route.params.id" class="article__link-back t-text--xsmall u-marg-b-md u-inline-block">
        <img src="/images/arrow-back.svg" alt="" class="article__link-back__ico u-inline-block u-marg-r-sm">
        <span class="t-text--xsmall u-white u-inline-block u-uppercase">Back to buildings</span>
      </router-link>
      <div class="card__header u-flex u-between u-marg-b-sm">
        <ul>
          <li v-for="tag in content.sbsSubject" class="u-inline-block u-marg-r-sm"><app-tag :content="tag"></app-tag></li>
        </ul>

        <div class="u-inline-block">
          <button class="article__btn-share t-button--simple u-relative u-inline-block u-marg-r-sm" @click="onShare">
            <img src="/images/share.svg" alt="" class="article__btn-share__ico">
          </button>
          <button class="card__header__btn-fav t-button--simple u-relative u-inline-block" :class="{'is-active': isFav}" @click="onToggleFav">
            <img src="/images/fav-border.svg" alt="" class="card__header__btn-fav__ico u-full-width">
            <img src="/images/fav-gradient.svg" alt="" class="card__header__btn-fav__ico u-absolute u-full-width">
          </button>
        </div>

      </div>
      <div class="u-w6of8 u-marg-b-md u-w8of8--sm">
        <p class="article__title t-h3 u-marg-t-sm u-white u-marg-b-sm">{{content.title}}</p>
        <div class="u-marg-b-sm"">
          <p v-if="content.date" class="t-text--small u-inline-block u-white u-marg-r-xs">{{formatDate(content.date)}}</p>
          <p v-if="content.sbsDuration" class="t-text--small t-text--gradient-green u-inline-block">- {{content.sbsDuration}}</p>
        </div>
        <p v-if="content.sousTitre" class="t-text--small u-white u-w6of8 u-w8of8--md">{{content.sousTitre}}</p>
      </div>
      <button v-if="!isReadMode" class="article__btn-read t-text--small t-button--simple u-white u-uppercase u-full-width u-marg-b-md" @click="onOpenModal">
          <img src="/images/read-mode.svg" alt="" class="article__btn-read__ico u-inline-block u-marg-r-sm">
          <span class="u-inline-block">{{ $t('district.readFull') }}</span>
      </button>

      <core-object-box v-if="content.image && content.image.length > 0" :width="content.image[0].width" :height="content.image[0].height" class="u-marg-b-md u-bg-grey">
        <app-image :id="content.image[0].id" :width="400" class="u-block u-wrapper-panel"></app-image>
      </core-object-box>

      <div v-if="content.sectionHandle === 'sbsVideo' && isEnterAnimationOver" class="u-box-16by9 u-bg-grey">
        <video-player
          v-if="content.sbsVideo.length"
          :src="content.sbsVideo[0].url"
          :subtitles="content.sbsSubtitles.length ? content.sbsSubtitles[0].url : ''"
        />
        <youtube-player v-else :id="content.sbsIdVimeo" />
      </div>

      <div v-if="content.sectionHandle === 'sbsPdf' && isEnterAnimationOver" class="u-box-16by9 u-bg-grey">
        <iframe :src="content.sbsPdfUrl" width="400" height="600" :title="content.title" class="u-wrapper-panel"></iframe>
      </div>

      <div v-if="content.wysiwyg" class="article__wysiwyg t-text u-grey-light" v-html="content.wysiwyg"></div>
    </div>
  </article>
</template>

<script>
import AppImage from '@/components/common/AppImage'
import AppTag from '@/components/common/AppTag'
import VideoPlayer from '@/components/common/VideoPlayer'
import YoutubePlayer from '@/components/common/YoutubePlayer'
import CoreObjectBox from '@/components/common/CoreObjectBox'
import Favorite from '@/components/common/Favorite'

export default {
  components: {
    AppImage,
    AppTag,
    VideoPlayer,
    CoreObjectBox,
    YoutubePlayer
  },

  mixins: [Favorite],

  props: {
    content: {
      type: Object,
      default: null
    },
    isReadMode: 
    {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isEnterAnimationOver: false
    }
  },

  mounted() {
    // wait the end of the animation before creating iframe
    // iframe creation = lag
    setTimeout(() => {
      this.isEnterAnimationOver = true
    }, 250)
  },

  methods: {
    formatDate (date) {
      date = new Date(date)
      return `${this.formatMonth(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`
    },

    formatMonth (mounth) {
      switch (mounth){
        case 0:
          return 'Jan'
          break
        case 1:
          return 'Fev'
          break
        case 2:
          return 'Mar'
          break
        case 3:
          return 'Apr'
          break
        case 4:
          return 'May'
          break
        case 5:
          return 'Jun'
          break
        case 6:
          return 'Jul'
          break
        case 7:
          return 'Aug'
          break
        case 8:
          return 'Sep'
          break
        case 9:
          return 'Oct'
          break
        case 10:
          return 'Nov'
          break
        case 11:
          return 'Dec'
          break
        default:
          return ''
          break
      }
    },

    onOpenModal () {
      this.$ga.send('Content', 'Click', 'Full-screen mode')
      this.$emit('modal:open', this.content)
    },

    onShare () {
      if(navigator.share)
      {
        navigator.share({
          title: this.content.title,
          url: this.$route.fullPath
        })
        .then(() =>
        {
            console.log('Thanks for sharing !');
        })
        .catch(console.error);
      }
      else
      {
        console.log(':(')
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.article
  z-index 1
  transform translateZ(0)
  transition transform .8s ease-out-quart
  
  &-enter,
  &-leave-to
    transform translateX(100%) translateZ(0)
    
.article__content
  transform translateX(0) translateZ(0)
  transition transform .8s ease-out-quart, opacity .6s
  
  .article-enter &,
  .article-leave-to &
    opacity 0
    transform translateX(-50px) translateZ(0)
    
  .article-enter-active &
    transition-delay .1s, .1s

.article__title
  &:after 
    position relative
    display block
    content ''
    
    width 60%
    height 1px
    background $gradients.green
    margin-top 10px
    
.article__btn-read
  border-radius 22px
  border 1px solid $colors.white
  padding: $spacings.sm $spacings.md
  
.article__btn-read__ico
  width 40px
  
.article__link-back__ico
  width 8px
  
.article__btn-share__ico
  width 20px
  
.article__wysiwyg
  p
    margin-bottom 20px
    
  h1, h2, h3, h4, h5, h6
    color $colors.white
  
</style>